export const FEATURE_ORGANIC_ID = 'F1';
export const MATERIAL_SUSTAINABLE_ID = 'MAT_3';
export const REFINEMENT_SCREEN_PRINT_ID = 'REF_2';
